import { Menu, Typography, Tooltip, Button } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { TitleAction } from '../../shared-components/TitleAction';
import { changeTitle } from '../../../../redux/actions/app';
import { ReactComponent as dtm_icon } from '../../../../assets/icons/Digital_Threat_Icon.svg';
import Icon, { UserOutlined, PlusOutlined } from '@ant-design/icons';
import { ReactComponent as shared_icon } from '../../../../assets/icons/SharedIcon.svg';
import { ReactComponent as public_icon } from '../../../../assets/icons/public.svg';
import styles from '../LeftMenuSidebar/left-menu-sidebar.module.sass';
import PermissionLookupTable from '../../../../shared-components/PermissionLookupTable';
import cx from 'classnames';

export function DigitalThreatManagementSubMenu(props) {
  const scopeIconMapping = {
    USER: <UserOutlined />,
    ORGANISATION: <Icon component={shared_icon} />,
    GLOBAL: <Icon component={public_icon} />,
  };

  const { Title, Text } = Typography;
  const {
    isKeyOn,
    setSessionStorage,
    toggleKey,
    setClearRecipe,
    ...rest
  } = props;

  const DigitalThreatMappingIcon = (props) => <Icon component={dtm_icon} />;
  const dispatch = useDispatch();
  const digitalThreatManagementLeftMenuData = useSelector(
    (state) => state.ioc.digitalThreatManagementLeftMenuData,
  );

  return (
    <>
      <Menu.SubMenu
        data-cy={`leftMenuSidebarDigitalThreatManagement`}
        title={
          <TitleAction
            menuKey={'digital-threat-management'}
            title={
              <div className={styles.section_title}>
                <div className={styles.border} />
                <DigitalThreatMappingIcon />
                <Title level={5}>Digital Threat Management</Title>
              </div>
            }
            showDownArrow={props.isKeyOn('digital-threat-management')}
          />
        }
        className={styles.main_menu_option}
        {...rest}
      >
        <Menu.SubMenu
          data-cy={`leftMenuSidebarBrandImpersonation`}
          className={styles.first_level_submenu}
          title={
            <TitleAction
              menuKey={'brand-impersonation-submenu'}
              title={
                <Text className={styles.additional_indentation} strong>
                  Brand Impersonation
                </Text>
              }
              showDownArrow={props.isKeyOn('brand-impersonation-submenu')}
              titleAction={() => props.toggleKey('brand-impersonation-submenu')}
              is_parent={true}
              itemLabel={'Brand Impersonation'}
            />
          }
          onTitleClick={(e) => {
            props.toggleKey('brand-impersonation-submenu');
          }}
          key={'brand-impersonation-submenu'}
        >
          <Menu.Item
            key={'brand-impersonation'}
            disabled={
              !PermissionLookupTable(
                'brand-impersonation',
                props.mySubscriptionPlan,
              )
            }
          >
            {!PermissionLookupTable(
              'brand-impersonation',
              props.mySubscriptionPlan,
            ) ? (
              <Tooltip
                title={
                  <>
                    Brand Impersonation recipe is not part of this subscription
                    plan. To upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                }
                placement={'right'}
              >
                <Button className={styles.add_new_button} type="link">
                  Create New
                  <PlusOutlined />
                </Button>
              </Tooltip>
            ) : (
              <Tooltip
                title={'Create New Brand Impersonation Recipe'}
                placement={'right'}
              >
                <Link
                  to={`/explore/brand-impersonation/?left_menu_name=Brand Impersonation`}
                >
                  <Button
                    className={styles.add_new_button}
                    onClick={() => {
                      props.setClearRecipe();
                      dispatch(changeTitle('Brand Impersonation', null));
                      props.setSessionStorage(
                        'create-brand-impersonation-menu-item',
                      );
                    }}
                    type="link"
                  >
                    Create New
                    <PlusOutlined />
                  </Button>
                </Link>
              </Tooltip>
            )}
          </Menu.Item>

          <Menu.SubMenu
            data-cy={`leftMenuSidebarDomainImpersonation`}
            className={styles.second_level_submenu}
            title={
              <TitleAction
                menuKey={'my-brand-impersonation'}
                title={
                  <div className={styles.secondary_section_title}>
                    <Text className={styles.additional_indentation}>
                      Domain Impersonation
                    </Text>
                  </div>
                }
                showDownArrow={props.isKeyOn('my-brand-impersonation')}
                titleAction={() => props.toggleKey('my-brand-impersonation')}
              />
            }
            onTitleClick={(e) => {
              props.toggleKey('my-brand-impersonation');
            }}
            key={'my-brand-impersonation'}
          >
            {digitalThreatManagementLeftMenuData?.[0]?.children?.map(
              (mi, midx) =>
                !PermissionLookupTable(
                  'brand-impersonation',
                  props.mySubscriptionPlan,
                ) ? (
                  props.returnSubstituteMenu({
                    type: 'subMenuItem',
                    tooltipMessage: (
                      <>
                        Domain Impersonation is not part of this subscription
                        plan. To upgrade your subscription contact us at{' '}
                        <a target="_blank" href="mailto:sales@silentpush.com">
                          sales@silentpush.com
                        </a>
                        .
                      </>
                    ),
                    menuTitle: (
                      <>
                        <span style={{ marginRight: '4px' }}>
                          {scopeIconMapping[mi.scope]}
                        </span>
                        <span>{mi?.label}</span>
                      </>
                    ),
                    icon: null,
                  })
                ) : (
                  <Menu.Item
                    data-cy="digitalThreatManagementSubMenuSavedRecipe"
                    onClick={() => {
                      props.setSessionStorage(mi.value);
                      //props.toggleKey(mi.value + '-savedRecipe');
                    }}
                    key={mi.value + '-savedRecipe'}
                  >
                    <TitleAction
                      menuKey={mi.value}
                      title={
                        <Tooltip
                          placement="right"
                          title={mi?.label?.length > 20 ? mi?.label : ''}
                        >
                          <div className={styles.secondary_section_title}>
                            <Link
                              to={
                                `/explore/brand-impersonation` +
                                `?recipeid=${mi.value}&left_menu_name=Brand Impersonation`
                              }
                              className={styles.additional_indentation}
                            >
                              <span style={{ marginRight: '4px' }}>
                                {scopeIconMapping[mi.scope]}
                              </span>
                              <span>
                                {mi?.label?.length > 20
                                  ? mi?.label?.substr(0, 20) + '...'
                                  : mi?.label}
                              </span>
                            </Link>
                          </div>
                        </Tooltip>
                      }
                    />
                  </Menu.Item>
                ),
            )}
          </Menu.SubMenu>
        </Menu.SubMenu>

        <Menu.SubMenu
          data-cy={`leftMenuSidebarNamiInTxtRecord`}
          className={cx(styles.first_level_submenu, styles.exceptionBackground)}
          key={'name-in-txt-submenu'}
          onTitleClick={(e) => {
            props.toggleKey('name-in-txt-submenu');
          }}
          title={
            <TitleAction
              menuKey={'name-in-txt-submenu'}
              title={
                <Text className={styles.additional_indentation} strong>
                  Name in TXT Record
                </Text>
              }
              showDownArrow={props.isKeyOn('name-in-txt-submenu')}
              titleAction={() => props.toggleKey('name-in-txt-submenu')}
              is_parent={true}
              itemLabel={'Name in TXT Record'}
            />
          }
        >
          <Menu.Item
            key={'name-in-txt'}
            disabled={
              !PermissionLookupTable('name-in-txt', props.mySubscriptionPlan)
            }
          >
            {!PermissionLookupTable('name-in-txt', props.mySubscriptionPlan) ? (
              <Tooltip
                title={
                  <>
                    Name in TXT Record recipe is not part of this subscription
                    plan. To upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                }
                placement={'right'}
              >
                <Button className={styles.add_new_button} type="link">
                  Create New
                  <PlusOutlined />
                </Button>
              </Tooltip>
            ) : (
              <Tooltip
                title={'Create New Name in TXT Record Recipe'}
                placement={'right'}
              >
                <Link
                  to={`/explore/name-in-txt/?left_menu_name=Name in TXT Record`}
                >
                  <Button
                    className={styles.add_new_button}
                    onClick={() => {
                      dispatch(changeTitle('Name in TXT Record', null));
                      props.setSessionStorage('create-name-in-txt-menu-item');
                    }}
                    type="link"
                  >
                    Create New
                    <PlusOutlined />
                  </Button>
                </Link>
              </Tooltip>
            )}
          </Menu.Item>
          {digitalThreatManagementLeftMenuData?.[1]?.children?.map((mi, midx) =>
            !PermissionLookupTable('name-in-txt', props.mySubscriptionPlan) ? (
              props.returnSubstituteMenu({
                type: 'subMenuItem',
                tooltipMessage: (
                  <>
                    Name in TXT Record is not part of this subscription plan. To
                    upgrade your subscription contact us at{' '}
                    <a target="_blank" href="mailto:sales@silentpush.com">
                      sales@silentpush.com
                    </a>
                    .
                  </>
                ),
                menuTitle: (
                  <>
                    <span style={{ marginRight: '4px' }}>
                      {scopeIconMapping[mi.scope]}
                    </span>
                    <span>{mi?.label}</span>
                  </>
                ),
                icon: null,
              })
            ) : (
              <Menu.Item
                data-cy="digitalThreatManagementSubMenuSavedRecipe"
                onClick={() => {
                  props.setSessionStorage(mi.value);
                  props.toggleKey(mi.value + '-savedRecipe');
                }}
                key={mi.value + '-savedRecipe'}
              >
                <TitleAction
                  menuKey={mi.value}
                  title={
                    <Tooltip
                      placement="right"
                      title={mi?.label?.length > 20 ? mi?.label : ''}
                    >
                      <div className={styles.secondary_section_title}>
                        <Link
                          to={
                            `/explore/name-in-txt` +
                            `?recipeid=${mi.value}&left_menu_name=Name in TXT Record`
                          }
                          className={styles.additional_indentation}
                        >
                          <span style={{ marginRight: '4px' }}>
                            {scopeIconMapping[mi.scope]}
                          </span>
                          <span>
                            {mi?.label?.length > 20
                              ? mi?.label?.substr(0, 20) + '...'
                              : mi?.label}
                          </span>
                        </Link>
                      </div>
                    </Tooltip>
                  }
                />
              </Menu.Item>
            ),
          )}
        </Menu.SubMenu>
      </Menu.SubMenu>
    </>
  );
}
